export enum ESearchSteps {
    SELECT_DATE = 1,
    SELECT_PARENT,
    CONTACT_PARENT,
    PREPARE_MESSAGE,
    SEND_DEMAND,
}